import JSZip from 'jszip';
import pako from 'pako';

export default {
  JSZip,
  pako,
};
